import view from '../../view';
import isNumeric from '../../../utils/is-numeric';
import findAllFor from '../filters/find-all-for';
import isContenteditableDisabled from '../helpers/is-contenteditable-disabled';

const canBeInteracted = (element) => {
  const constraints = findAllFor(element);
  const liveDocument = view.accessors.getLiveDocument();

  if (!constraints.length) {
    return false;
  }

  const isContenteditable = constraints.every(
    (constraint) => constraint.contenteditable && !isContenteditableDisabled(constraint)
  );

  if (isContenteditable) {
    return true;
  }

  return constraints.some((constraint) => {
    if (
      constraint.draggable ||
      constraint.removable ||
      constraint.movable ||
      constraint.alignable ||
      constraint.hideable
    ) {
      return true;
    }

    if (isNumeric(constraint.maxCount)) {
      return (
        constraint.cloneable &&
        liveDocument.querySelectorAll(constraint.element).length < constraint.maxCount
      );
    }

    return constraint.cloneable;
  });
};

export default canBeInteracted;
